/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateConversationDto
 */
export interface CreateConversationDto {
    /**
     * Patient ID
     * @type {string}
     * @memberof CreateConversationDto
     */
    patientId: string;
    /**
     * Provider ID
     * @type {string}
     * @memberof CreateConversationDto
     */
    providerId: string;
}

/**
 * Check if a given object implements the CreateConversationDto interface.
 */
export function instanceOfCreateConversationDto(value: object): value is CreateConversationDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('providerId' in value) || value['providerId'] === undefined) return false;
    return true;
}

export function CreateConversationDtoFromJSON(json: any): CreateConversationDto {
    return CreateConversationDtoFromJSONTyped(json, false);
}

export function CreateConversationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateConversationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'providerId': json['providerId'],
    };
}

export function CreateConversationDtoToJSON(json: any): CreateConversationDto {
    return CreateConversationDtoToJSONTyped(json, false);
}

export function CreateConversationDtoToJSONTyped(value?: CreateConversationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'providerId': value['providerId'],
    };
}

